<template>
  <div class="page">
    <div class="form">
      <div class="pageTitleBox">
        <div class="boxNameL">洗美项目编辑</div>
        <div class="boxNameR">
          <el-button type="warning" @click="$router.back()" size="small"
            >返回</el-button
          >
        </div>
      </div>
    </div>
    <div style="margin: 10px; font-size: 14px">基础设置</div>
    <div class="pageBox">
      <div class="pageView">
        <div class="pageItem">
          <div class="pageTit">预约类型:</div>
          <div class="screenLine">
            <el-select v-model="projectType" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id + ',' + item.name"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="pageItem">
          <div class="pageTit">适用宠物:</div>
          <div class="screenLine">
            <el-checkbox-group v-model="fitPetList">
              <el-checkbox
                v-for="item in petList"
                :label="item"
                :key="item.id + ',' + item.name"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </div>
        <div class="pageItem">
          <div class="pageTit">适用职业:</div>
          <div class="screenLine">
            <el-checkbox-group v-model="fitPositionList">
              <el-checkbox
                v-for="item in positionList"
                :label="item"
                :key="item.id + ',' + item.name"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div class="pageView">
        <div class="pageItem">
          <div class="pageTit">项目名称:</div>
          <div class="screenLine">
            <el-input
              v-model="projectName"
              placeholder="请输入内容"
              width="227px"
            ></el-input>
          </div>
        </div>
        <div class="pageItem">
          <div class="pageTit">参与门店:</div>
          <div class="screenLine">
            <div>
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
            </div>
            <el-checkbox-group
              v-model="shopList"
              @change="handleCheckedCitiesChange"
            >
              <el-checkbox
                v-for="item in cities"
                :label="item"
                :key="item.id + ',' + item.shop_name"
                >{{ item.shop_name }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </div>
        <div class="pageItem"></div>
      </div>
      <div class="pageView">
        <div class="pageItem">
          <div class="pageTit">项目排序:</div>
          <div class="screenLine">
            <el-input
              v-model="sort"
              type="number"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>
      </div>
    </div>
    <div style="margin: 10px; font-size: 14px">线上介绍</div>
    <div class="pageBox">
      <div class="pageItemT">
        <div>封面图:</div>
        <div class="screenLine">
          <div class="drawerComR" style="display: flex">
            <div class="imgItem" style="display: inline-block">
              <img alt="" :src="coverImg" v-if="coverImg" class="avatar" />
              <i
                class="el-icon-error closeBtn"
                v-if="coverImg"
                @click="handleDeleteCoverImgClick"
              ></i>
            </div>
            <i
              class="el-icon-plus avatar-uploader-icon"
              @click="handleUploadClicks"
              v-if="!coverImg"
            ></i>
            <input
              type="file"
              ref="files"
              style="width: 0; height: 0"
              @change="changeFiles"
            />
          </div>
        </div>
      </div>
      <div class="pageItemT" style="margin-bottom: 10px; margin-top: 10px">
        <div>介绍:</div>
        <div class="screenLine">
          <el-input type="textarea" v-model="introduce"></el-input>
        </div>
      </div>
      <div class="pageItemT">
        <div>介绍图片:</div>
        <div class="screenLine">
          <div class="drawerComR" style="display: flex">
            <div
              v-for="(item, index) in detailImgs"
              :key="index"
              class="imgItem"
              style="display: inline-block"
            >
              <img
                alt=""
                :src="item"
                v-if="detailImgs.length > 0"
                class="avatar"
              />
              <i
                class="el-icon-error closeBtn"
                v-if="detailImgs.length > 0"
                @click="handleDeleteBannerImgClick(index)"
              ></i>
            </div>
            <i
              class="el-icon-plus avatar-uploader-icon"
              @click="handleUploadClick"
              v-if="detailImgs.length < 4"
            ></i>
            <input
              type="file"
              ref="file"
              style="width: 0; height: 0"
              @change="changeFile"
            />
          </div>
        </div>
      </div>
      <div
        style="
          width: 100%;
          height: 1px;
          background: #f2f2f2;
          margin-top: 20px;
          margin-bottom: 40px;
        "
      ></div>
      <div>
        <div>
          宠物洗护时长设置
          <el-button
            type="warning"
            style="margin-left: 10px"
            size="mini"
            @click="add"
            >添加</el-button
          >
        </div>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="宠物种类">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.petType"
                placeholder="请选择"
                @change="changePet(scope.row.petType, scope.$index)"
              >
                <el-option
                  v-for="item in fitPetList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id + ',' + item.name"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="品种">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.petClass"
                placeholder="请选择"
                :disabled="scope.row.disabled"
                :multiple-limit="scope.row.limit"
                multiple
                reserve-keyword
                @change="petBreed(scope.row.petClass, scope.$index)"
              >
                <el-option
                  v-for="item in scope.row.petBreedList"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id + ',' + item.name"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="毛发">
            <template slot-scope="scope">
              <el-select
                multiple
                v-model="scope.row.petHairTypeList"
                placeholder="请选择"
                :disabled="scope.row.disabled"
              >
                <el-option
                  v-for="item in petHairList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id + ',' + item.name"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="体型">
            <template slot-scope="scope">
              <el-select
                multiple
                v-model="scope.row.petBodilyTypeList"
                placeholder="请选择"
                :disabled="scope.row.disabledT"
              >
                <el-option
                  v-for="item in scope.row.weightList"
                  :key="item.typeNum"
                  :label="item.typeName"
                  :value="
                    item.typeNum +
                    ',' +
                    item.typeName +
                    ',' +
                    item.min +
                    ',' +
                    item.max
                  "
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="预估洗护时长">
            <template slot-scope="scope">
              <!-- duration -->
              <el-input
                type="number"
                v-model="scope.row.duration"
                @change="changeDuration(scope.row.duration)"
                placeholder="洗护时长为10的倍数"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        style="
          display: flex;justify-content: center; margin-top: 30px;
          margin-bottom: 30px;
        "
      >
        <el-button
          type="warning"
          size="mini"
          style="
            margin-left: 10px;
            width: 170px;
            height: 40px;
            background: #f5882a;
            border-radius: 4px;
          "
          @click="addConfig"
          >提交</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      multiple: true, //品种多选
      disabled: false, //禁用
      // 毛发
      petHairType: "",
      petHairList: [
        { id: "1", name: "长毛" },
        { id: "2", name: "短毛" },
      ],
      petList: [
        { id: "1", name: "猫猫" },
        { id: "2", name: "狗狗" },
        { id: "3", name: "异宠" },
      ],
      tableData: [],
      petType: "",
      value: "",
      options: [
        {
          id: "1",
          name: "洗澡",
        },
        {
          id: "2",
          name: "美容",
        },
        {
          id: "3",
          name: "单项服务",
        },
      ],
      radio: 3,
      projectName: "",
      projectType: "",
      sort: "",
      shopList: [], //参与门店
      cities: this.$store.state.myShopList,
      positionList: [
        { id: "1", name: "美容师" },
        { id: "2", name: "美容师助理" },
      ],
      isIndeterminate: true,
      checkAll: true,
      imageUrl: "",
      introduce: "", //介绍
      checked: true,
      fitPetList: [],
      fitPositionList: [],
      detailImgs: [], //详情图片集合
      coverImg: "", //封面图
      petBreedList: [], //宠物品种
      shopsList: [],
      durationConfigList: [],
      petBodilyTypeList: [],
      petHairTypeList: [],
    };
  },
  mounted() {},
  methods: {
    // 添加配置
    addConfig() {
      if (!this.projectType) {
        this.$message.error("请选择预约类型");
        return;
      }
      if (!this.fitPetList.length) {
        this.$message.error("请选择适用宠物");
        return;
      }
      if (!this.fitPositionList.length) {
        this.$message.error("请选择适用职业");
        return;
      }
      if (!this.projectName) {
        this.$message.error("请输入项目名称");
        return;
      }
      if (!this.shopList.length) {
        this.$message.error("请选择参与门店");
        return;
      }
      if (!this.tableData.length) {
        this.$message.error("请添加洗护时长");
        return;
      }
      if (!this.sort) {
        this.$message.error("请添加项目排序");
        return;
      }
      if (this.shopList.length) {
       
        this.shopList.forEach((a) => {
          const obj = {
            shopId: a.shop_id,
            shopName: a.shop_name,
          };
          this.shopsList.push(obj);
        });
      } else {
        this.$message.error("请选择参与门店");
      }
      // console.log(this.tableData);
      if (this.tableData.length) {
        let flag = false;
        this.tableData.forEach((item) => {
          if (!item.petType) {
            flag = true;
            return;
          }
        });
        if (flag) {
          this.$message.error("请选择完善洗护信息");
          return;
        }
      }
      if (this.tableData.length > 0) {
        this.tableData.forEach((item) => {
          // console.log('item',item);
          item.petClass.forEach((b) => {
            let obj = {
              id: b.split(",")[0],
              name: b.split(",")[1],
            };
            // console.log(obj);
            item.petClassT.push(obj);
            //  console.log('petClassT',item.petClassT);
          });
          item.petBodilyTypeList.forEach((b) => {
            let obj = {
              typeNum: b.split(",")[0],
              typeName: b.split(",")[1],
              min: b.split(",")[2],
              max: b.split(",")[3],
            };
            item.petBodilyTypeListT.push(obj);
          });
          item.petHairTypeList.forEach((b) => {
            let obj = {
              id: b.split(",")[0],
              name: b.split(",")[1],
            };
            item.petHairTypeListT.push(obj);
          });
          let objA = {
            duration: parseInt(item.duration),
            petType: {
              id: item.petType.split(",")[0],
              name: item.petType.split(",")[1],
            },
            petClassList: item.petClassT,
            petHairTypeList: item.petHairTypeListT,
            petBodilyTypeList: item.petBodilyTypeListT,
          };
          // console.log('objA',objA);
          this.durationConfigList.push(objA);
        });
      }
      let params = {
        projectName: this.projectName,
        projectType: {
          id: this.projectType[0],
          name: this.projectType.split(",")[1],
        },
        fitPetList: this.fitPetList,
        fitPositionList: this.fitPositionList,
        sort: parseInt(this.sort),
        coverImg: this.coverImg,
        introduce: this.introduce,
        detailImgs: this.detailImgs,
        shopList: this.shopsList,
        durationConfigList: this.durationConfigList,
      };
      // console.log('添加项目配置',params);
      let loading = this.$loading();
      this.$http
        .post(process.env.VUE_APP_AppAdmin + "/api/Resvere/AddConfig", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.$message({
              showClose: true,
              message: "添加配置成功",
              type: "success",
            });
          }
        });
    },
    changeDuration(num) {
      if (num % 10 !== 0) {
        this.$message.error("洗护时长应为10的倍数");
      }
    },
    petBreed(a, index) {
      a.forEach((item) => {
        console.log(item.indexOf("通用") != -1);
        if (item.indexOf("通用") != -1) {
          this.tableData[index].limit = 1;
        }
      });
    },
    changePet(a, index) {
      let arr = [];
      arr = a.split(",");
      // this.projectType[0] == 3
      if (arr[0] == "3"||this.projectType[0] == 3) {
        this.tableData[index].disabled = true;
      } else {
        let params = {
          applyType: parseInt(arr[0]),
        };
        let loading = this.$loading();
        this.$http
          .get(process.env.VUE_APP_Url2 + "api/product/pet/Breed/list", params)
          .then((res) => {
            loading.close();
            res.data.unshift({ name: "通用", _id: "1" });
            this.tableData[index].petBreedList = res.data;
            this.tableData[index].disabled = false;
            // console.log("列表", res.data);
          });
      }
      // 获取体重配置列表 1猫2狗3异宠
      let loading = this.$loading();
      this.$http
        .get(
          process.env.VUE_APP_AppAdmin +
            "/api/Resvere/GetWeightConfigDetailByPetType",
          {
            petType: parseInt(arr[0]),
          }
        )
        .then((res) => {
          loading.close();
          this.tableData[index].weightList = res.data.configList;
          console.log("体重配置列表", res.data.configList);
        });
    },
    add() {
      if (this.projectType[0] == 3) {
        let obj = {
          disabled: true,
          disabledT: true,
          petClass: [],
          petClassT: [],
          duration: "", //洗护时长
        };
        this.tableData.push(obj);
      } else {
        let obj = {
          petType: "",
          petHairType: "",
          petClass: [],
          petClassT: [],
          disabled: false,
          disabledT: false,
          petBreedList: [],
          limit: 0,
          weightList: [],
          petBodilyTypeList: [], //体重配置
          petBodilyTypeListT: [], //体重配置
          duration: "", //洗护时长
          petHairTypeList: [], //毛发配置
          petHairTypeListT: [], //毛发配置
        };
        this.tableData.push(obj);
      }
    },
    handleDelete(index) {
      this.tableData.splice(index, 1);
    },
    //转移详情
    handleUploadClicks() {
      this.$refs.files.click();
    },
    //转移触发轮播图上传按钮
    handleUploadClick() {
      this.$refs.file.click();
    },
    //上传封面图
    changeFiles(e) {
      let that = this;
      var index = e.target.files[0].name.lastIndexOf(".");
      var ext = e.target.files[0].name.substr(index + 1);
      var formData = new FormData();
      if (ext === "png" || ext === "jpg" || ext === "jpeg") {
        formData.append("img", e.target.files[0]);
        this.$upload
          .uploadImg_dir(formData, { dir: "businessShopImg" })
          .then((data) => {
            if (data.timestamp) {
              that.coverImg = data.url;
            }
          });
      } else {
        this.$message({
          message: "只能上传jpg,png格式的文件",
          type: "error",
        });
      }
    },
    //上传轮播图
    changeFile(e) {
      let that = this;
      var index = e.target.files[0].name.lastIndexOf(".");
      var ext = e.target.files[0].name.substr(index + 1);
      var formData = new FormData();
      if (ext === "png" || ext === "jpg" || ext === "jpeg") {
        formData.append("img", e.target.files[0]);
        this.$upload
          .uploadImg_dir(formData, { dir: "businessShopImg" })
          .then((data) => {
            if (data.timestamp) {
              that.detailImgs.push(data.url);
            }
          });
      } else {
        this.$message({
          message: "只能上传jpg,png格式的文件",
          type: "error",
        });
      }
    },
    //删除封面图
    handleDeleteCoverImgClick() {
      this.coverImg = "";
    },
    //删除轮播图图片
    handleDeleteBannerImgClick(index) {
      this.detailImgs.splice(index, 1);
    },
    // 上传图片
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 全选
    handleCheckAllChange(val) {
      // console.log(val);
      this.shopList = val ? this.cities : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.pageItemT {
  display: flex;
  .screenLine {
    margin-left: 10px;
  }
}
.page {
  .pageBox {
    line-height: 50px;
    font-size: 12px;
    color: #333;
    padding: 10px 16px;
    margin-bottom: 12px;
    background-color: #fff;
    border-radius: 4px;
  }
  .pageView {
    // display: flex;

    .pageItem {
      display: flex;
      margin-right: 200px;
      .screenLine {
        margin-left: 10px;
      }
    }
  }
}

// 上传图片
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 80px;
  border: 1px #8c939d dashed;
  line-height: 80px;
  text-align: center;
}

.drawerComR {
  flex: 1;
  .avatar-uploader .el-upload {
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: #f0f0f7;
    border: 1px dashed #b0b0bf;
    border-radius: 8px;
    box-sizing: border-box;
  }
  .avatar {
    width: 100px;
    height: 60px;
    display: block;
    object-fit: cover;
  }
}
.imgItem {
  position: relative;
  margin-right: 15px;
}
.imgItem i {
  position: absolute;
  top: -10px;
  right: -10px;
}
</style>